




































































































































import {
  getComponent,
  getComponentByInspectUid,
  sortItems,
  genPostReq
} from "@/services/checklist.service";

import TransferInspectModal from "@/components/TransferInspectModal.vue";
import ImportChecklistModal from "@/components/ImportChecklistModal.vue";
import draggable from "vuedraggable";
import { EventBus } from '@/event-bus.js';

export default {
  props: ["inspect_uid", "blade_nr"],
  data() {
    return {
      na1: false,
      initLoaded: true,

      main_comp2: null, 
      // ---- 
      main_comp3: null, 
      cld_components_3: null,
      main_comp4: null, 
      cld_components_4: null,
      main_comp5: null, 
      cld_components_5: null,

      main_comp6: null, 
      cld_components_6: null,
    };
  },
  components: {
     draggable,
  },

  mounted() {
    this.$store.state.headerTitle = this.$t('CHECKLISTS.NAV2')
    this.$store.state.cl_uid = this.$route.params.uid;

    getComponentByInspectUid(this.$store.state.cl_uid, this.inspect_uid)
      .then(resp => {
        //console.log("selectCmp getComponent", resp);
        this.showComponent = true;
        if (resp.status == "success") {

          if(resp.data && resp.data.details) {
            console.log(resp.data)

            this.main_comp2 = resp.data.component
            this.cld_components_3 = resp.data.details.children_list
          }

          //EventBus.$emit('comp_changed', {level: resp.data.level});
        }
      })
      .catch(e => {
        this.$store.dispatch("api_error", e);
      });

  },
  computed: {
    copy_entry_level() {
      return this.$store.state.copy_blades_entry && this.$store.state.copy_blades_entry.level
    }, 
    copy_entry() {
      return this.$store.state.copy_blades_entry && this.$store.state.copy_blades_entry.type == "component"
    },  
    copy_entry_name() { 
      return this.$store.state.copy_blades_entry && this.$store.state.copy_blades_entry.name
    }, 
    copy_entry_state() { 
      return this.$store.state.copy_blades_entry
    }, 
  },
  methods: {
    pasteEntry: function (level) {

      //let target_parent_uid =  (level==4) ? this.main_comp3 : this.main_comp4

    
      let d = { type: "component",
                cl_uid: this.$store.state.copy_blades_entry.cl_uid,
                entry_uid: this.$store.state.copy_blades_entry.uid,
                level: level,
                component_uid: "",
                task_uid: "",
                target_cl_uid: this.$store.state.copy_blades_entry.cl_uid,
                target_parent_uid: (level==4) ? this.main_comp3 : this.main_comp4.value      
              }

      console.log("paste paste", d)


      genPostReq('checklist', 'duplicate-rotorblade-entry', d)
      .then(resp => {

          console.log("resp", resp, level)
    
          if (resp.status == "success") {
            this["cld_components_"+level] = resp.data.data.children_list
            EventBus.$emit('show_toast', {text: this.$t('LABEL69')});
          }
         
      })
      .catch(e => {
        this.$store.dispatch("api_error", e);
      }); 



/*

    checklistDuplicateEntry(req.body.userId, 
                            req.body.type, 
                            req.body.cl_uid, 
                            req.body.entry_uid, 
                            req.body.level, 
                            req.body.component_uid, 
                            req.body.task_uid,
                            req.body.target_cl_uid,
                            req.body.target_parent_uid).then( data => {

*/

   
    

    },
    selCmp: function(level, deeplink) { 
      this.loadCmp(level, this.main_comp3)
    },
    loadCmp: function(level, comp_uid) {
      getComponent(this.$store.state.cl_uid, comp_uid, level)
        .then(resp => {
          if (resp.status == "success") {
            if (resp.data && resp.data.details) {
            this["cld_components_"+level] = resp.data.details.children_list
            }

          }
        })
        .catch(e => {
          this.$store.dispatch("api_error", e);
        });
    },
    itemClicked: function (level, item) {
      this["main_comp"+level] = item
      this.loadCmp(level+1, item.value)
    },
    openEntry: function (ev, level, item) {
      ev.stopPropagation()

      console.log(this.main_comp2, this.main_comp3, this.main_comp4, item) 

      let route;

      if (level == 4) {
        route = this.$router.resolve({path: '/checklist/'+this.$store.state.cl_uid+'/'+this.main_comp2.parent_id+'/'+this.main_comp2.uid+'/'+this.main_comp3+'/'+item.value});
        window.open(route.href, '_blank');
      }
      else if (level == 5) {
        route = this.$router.resolve({path: '/checklist/'+this.$store.state.cl_uid+'/'+this.main_comp2.parent_id+'/'+this.main_comp2.uid+'/'+this.main_comp3+'/'+this.main_comp4.value+'/'+item.value});
        window.open(route.href, '_blank');
      }      
      else {
        route = this.$router.resolve({path: '/checklist/'+this.$store.state.cl_uid+'/'+this.main_comp2.parent_id+'/'+this.main_comp2.uid+'/'+this.main_comp3+'/'+this.main_comp4.value+'/'+this.main_comp5.value+'/'+item.value});
        window.open(route.href, '_blank');
      }
    // http://localhost:8080/checklist/hQdYSJjoCQ81vosuUwR7Zpn/h3YkeHuepQTGjANh9Eh4itW/hKwwV4TmbgJz6u3an9GB4DD/h812oz4tQUyADtXibaFFL9h/c4/c5/t/q
      
    },
    copyEntry: function (ev, level, item) {
      ev.stopPropagation()
      
      this.$store.state.copy_blades_entry = { type: "component", 
                                              blade_nr: this.blade_nr, 
                                              cl_uid: this.$store.state.cl_uid, 
                                              level: level, 
                                              uid: item.value, 
                                              name: item.text }
      
      console.log(this.$store.state.copy_blades_entry)

    },
    sortEnd: function (level) {
      console.log(this["cld_components_"+level])
      sortItems(this["cld_components_"+level], { type: 'component', cl_uid: this.$store.state.cl_uid })
        .then(resp => {
          if (resp.status == "success") {
            EventBus.$emit('show_toast', {text: this.$t('LABEL70')});
          }
        })
        .catch(e => {
          this.$store.dispatch("api_error", e);
        });
    }
  }
};
